<div class="nano-banana" [class.nano-banana--embedded]="embedded">
    <header class="nano-banana__header" *ngIf="showHeader">
      <div class="nano-banana__branding">
        <div class="nano-banana__logo">
          <i class="fa-solid fa-spa"></i>
        </div>
        <h1 class="nano-banana__title">
          <span class="nano-banana__title-accent"> Expect Realistic </span>
        </h1>
      </div>
    </header>
  
    <div class="nano-banana__content">
      <div class="nano-banana__editor">
        <div class="nano-card">
          <div class="nano-card__header">
            <div class="nano-card__title">
              <i class="fa fa-wand-magic-sparkles"></i>
              Chest Vision (Consultation Preview)
            </div>
            <button
              class="nano-card__discard"
              type="button"
              *ngIf="previewUrl"
              (click)="clearSession()"
            >
              Discard
            </button>
          </div>
  
          <div class="nano-card__body">
            <label class="nano-dropzone" *ngIf="!previewUrl">
              <div class="nano-dropzone__icon">
                <i class="fa-solid fa-cloud-arrow-up"></i>
              </div>
              <p class="nano-dropzone__title"><span>Click to upload</span> or drag and drop</p>
              <p class="nano-dropzone__subtitle">PNG, JPG or WebP</p>
              <input type="file" accept="image/*" (change)="onFileChange($event)" />
            </label>
  
            <div class="nano-editor" *ngIf="previewUrl">
              <div class="nano-editor__grid">
                <div class="nano-panel">
                  <span class="nano-panel__label">Original</span>
                  <div class="nano-panel__frame">
                    <img [src]="previewUrl" alt="Original" />
                  </div>
                </div>
  
                <div class="nano-panel">
                  <span class="nano-panel__label">Result</span>
                  <div class="nano-panel__frame nano-panel__frame--result">
                    <ng-container *ngIf="currentResult; else resultState">
                      <img [src]="currentResult" alt="Result" />
                      <a
                        class="nano-download"
                        [href]="currentResult"
                        download="edited-image.png"
                        aria-label="Download edited image"
                      >
                        <i class="fa-solid fa-download"></i>
                      </a>
                    </ng-container>
  
                    <ng-template #resultState>
                      <div class="nano-status" *ngIf="processing.isProcessing; else idleState">
                        <span class="nano-spinner"></span>
                        <p>Generating consultation preview...</p>
                      </div>
                      <ng-template #idleState>
                        <p class="nano-idle">Select an augmentation size option, then apply.</p>
                      </ng-template>
                    </ng-template>
                  </div>
                </div>
              </div>
  
              <!-- Size Controls -->
              <div class="nano-prompt">
                <label for="sizeSelect">Choose Augmentation Size</label>
  
                <div class="nano-prompt__field">
                  <div class="nano-controls">
                    <div class="nano-control" style="flex: 1 1 auto;">
                      <label for="sizeSelect" class="nano-panel__label">
                        Size Option
                      </label>
                      <select
                        id="sizeSelect"
                        [(ngModel)]="selectedSize"
                        [disabled]="processing.isProcessing"
                      >
                        <option *ngFor="let s of sizeOptions" [ngValue]="s.value">
                          {{ s.label }} ({{ s.subtitle }})
                        </option>
                      </select>
                    </div>
  
                    <button
                      type="button"
                      class="nano-generate"
                      (click)="handleEdit()"
                      [disabled]="processing.isProcessing || !selectedFile"
                      style="white-space:nowrap;"
                    >
                      <span *ngIf="!processing.isProcessing">
                        Apply Preview <i class="fa-solid fa-paper-plane"></i>
                      </span>
                      <span *ngIf="processing.isProcessing">Processing...</span>
                    </button>
                  </div>
                </div>
  
                <p class="nano-error" *ngIf="processing.error">{{ processing.error }}</p>
  
                <p class="nano-idle" style="margin-top:10px;">
                  Selected:
                  <strong>{{ sizeLabel(selectedSize) }}</strong>
                  • Size <strong>{{ selectedSize }}</strong>
                  ({{ sizeWord(selectedSize) }})
                </p>
              </div>
            </div>
          </div>
        </div>
  
        <div class="nano-tip">
     
          </div>
          <div>
              <div class="nano-tip__icon">
 
            <p>           <i class="fa-solid fa-lightbulb"></i> Start with Moderate (Size 2). Adjust to Size 1 for a more conservative change or Size 3 for a fuller result.</p>
          </div>
        </div>
      </div>
  
      <div class="nano-banana__history">
        <div class="nano-card nano-card--history">
          <div class="nano-card__header">
            <div class="nano-card__title">
              <i class="fa-solid fa-clock-rotate-left" *ngIf="history.length > 0"></i>
              History
            </div>
            <span class="nano-count">{{ history.length }}</span>
          </div>
  
          <div class="nano-card__body nano-history">
            <div class="nano-empty" *ngIf="history.length === 0">
              <div class="nano-empty__icon">
                <i class="fa-solid fa-clock"></i>
              </div>
              <p>No previews yet. Upload an image to begin.</p>
            </div>
  
            <div class="nano-history__list" *ngIf="history.length > 0">
              <div class="nano-history__item" *ngFor="let item of history">
                <img [src]="item.editedUrl" alt="Edited" />
                <div class="nano-history__meta">
                  <p>"{{ item.prompt }}"</p>
                  <span>{{ item.timestamp | date: 'shortTime' }}</span>
                </div>
                <div class="nano-history__actions">
                  <button type="button" (click)="viewHistoryItem(item.editedUrl)" title="View result">
                    <i class="fa-regular fa-image"></i>
                  </button>
                  <button type="button" (click)="deleteHistoryItem(item.id)" title="Delete">
                    <i class="fa-solid fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <footer class="nano-mobile" *ngIf="showMobileFooter">
      <ng-container *ngIf="!previewUrl; else mobileGenerate">
        <label class="nano-mobile__button">
          <i class="fa-solid fa-cloud-arrow-up"></i>
          Choose Photo
          <input type="file" accept="image/*" (change)="onFileChange($event)" />
        </label>
      </ng-container>
  
      <ng-template #mobileGenerate>
        <button
          type="button"
          class="nano-mobile__button"
          (click)="handleEdit()"
          [disabled]="processing.isProcessing || !selectedFile"
        >
          <i class="fa-solid fa-wand-magic-sparkles"></i>
          Apply Preview (Size {{ selectedSize }} - {{ sizeWord(selectedSize) }})
        </button>
      </ng-template>
    </footer>
  </div>